module.exports = __webpack_public_path__ + "img/switch_off.e65872fb.jpg";